
import { userUid, firestore } from '../../../firebase/'

import { apiSyncReducer, apiSalveInColection } from 'scorpion-core';
import { reject } from 'q';

export function listarDinamicCustomForms(sincronizador) {
    apiSyncReducer(getColCustomForms().where("viewers." + userUid(), "==", true))(sincronizador)
}


export function salvaObj(form, tokenBanco, item) {
    return apiSalveInColection(getColObjForm(form, tokenBanco), item);
}
export function listarObjs(form, tokenBanco, sincronizador) {
    apiSyncReducer(getColObjForm(form, tokenBanco))(sincronizador)
}

export function salvaObjRaiz(tokenBanco, item) {
    return apiSalveInColection(getColObjFormRaiz(tokenBanco), item);
}
export function listarObjsRaiz(tokenBanco, sincronizador) {
    apiSyncReducer(getColObjFormRaiz(tokenBanco))(sincronizador)
}

export function getHistoricoRaiz(tokenBanco, uidObj, resolve) {
    let colObjs = getColObjFormRaiz(tokenBanco);
    let docObj = colObjs.doc(uidObj);
    let colHistorico = docObj.collection("Histórico");
    colHistorico.onSnapshot((snapshot) => {
        let retorno = []
        snapshot.forEach(function (doc) {
            retorno.push(doc.data());
        });
        resolve(retorno);
    })  
}


function getColObjForm(form, tokenBanco) {
    return firestore().collection("CustomForm").doc(form).collection(tokenBanco);
}

function getColObjFormRaiz(tokenBanco) {
    return firestore().collection("ValueCustomForm").doc(tokenBanco).collection("Values");
}

function getColCustomForms() {
    return firestore().collection("CustomForm");
}



// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicForms/api.js